<template>
    <div class="col-xl-3 col-lg-4 col-md-6 col-12 mb-3">
        <div class="card border shadow-lg h-100 mb-0">
            <div class="pt-3 px-3 pb-0">
                <img
                    v-if="imageUrl"
                    :src="imageUrl"
                    :alt="details.name"
                    class="w-100 rounded cursor-pointer border border-light"
                    style="height: 100px; object-fit: cover;"
                    @click.stop="$bvModal.show('meeting-room-image-' + details.uuid)"
                >
                <div v-else class="bg-light rounded d-flex align-items-center justify-content-center" style="height: 100px;">
                    <i class="mdi mdi-door-open text-muted font-size-24"></i>
                </div>
            </div>
            <div class="card-body d-flex flex-column px-3 pb-3 pt-2">
                <h6 class="font-weight-bold mb-1 text-break">{{ details.name || '--' }}</h6>
                <div class="d-flex flex-wrap justify-content-between align-items-center mt-2 mb-3">
                    <small class="text-muted">
                        <i class="fas fa-users mr-1"></i>
                        <strong>{{ details.capacity ?? '--' }}</strong> {{ $t('label.seats') }}
                    </small>
                    <b-badge v-if="details.isServeDeck" variant="info" class="mt-1">
                        <i class="mdi mdi-access-point-network mr-1"></i>Servedeck
                    </b-badge>
                </div>
                <div v-if="details.amenities && details.amenities.length" class="d-flex flex-wrap mb-2">
                    <div
                        v-for="amenity in details.amenities.slice(0, 3)"
                        :key="amenity.uuid"
                        class="d-flex align-items-center border border-light rounded-pill px-2 py-1 mr-1 mb-1"
                    >
                        <img
                            v-if="amenity.imageUrl"
                            :src="amenity.imageUrl"
                            class="mr-2"
                            style="width: 18px; height: 18px; object-fit: contain;"
                        >
                        <i v-else-if="amenity.icon" :class="[amenity.icon, 'mr-2']"></i>
                        <small>{{ amenity.name }}</small>
                    </div>
                    <b-badge
                        v-if="details.amenities.length > 3"
                        :id="'meeting-room-amenities-' + details.uuid"
                        variant="secondary"
                        class="align-self-center cursor-pointer mb-1"
                    >
                        +{{ details.amenities.length - 3 }} {{ $t('label.more') }}
                    </b-badge>
                    <b-popover
                        v-if="details.amenities.length > 3"
                        :target="'meeting-room-amenities-' + details.uuid"
                        triggers="hover focus"
                        placement="bottom"
                        custom-class="border border-light shadow-lg"
                    >
                        <div v-for="amenity in details.amenities.slice(3)" :key="amenity.uuid" class="d-flex align-items-center py-1">
                            <img
                                v-if="amenity.imageUrl"
                                :src="amenity.imageUrl"
                                :alt="amenity.name"
                                class="mr-2"
                                style="width: 18px; height: 18px; object-fit: contain;"
                            >
                            <i v-else-if="amenity.icon" :class="[amenity.icon, 'mr-2']"></i>
                            <small>{{ amenity.name }}</small>
                        </div>
                    </b-popover>
                </div>
                <div
                    class="bg-info text-white text-center rounded py-1 px-3 mt-auto cursor-pointer font-weight-bold"
                    @click.stop="$emit('openForm', details)"
                >
                    <i class="fas fa-calendar-check mr-1"></i>
                    {{ $t('label.bookNow') }}
                </div>
            </div>
        </div>
        <b-modal
            :id="'meeting-room-image-' + details.uuid"
            :title="details.name"
            hide-header-close
            size="xl"
            centered
        >
            <b-container fluid class="p-0 text-center">
                <img
                    :src="selectedImage || imageUrl"
                    :key="selectedImage || imageUrl"
                    :alt="details.name"
                    class="img-fluid border border-light fade-in"
                    style="max-height: 70vh; object-fit: contain;"
                >
                <div v-if="details.images.length > 1" class="d-flex flex-wrap justify-content-center mt-3">
                    <img
                        v-for="image in details.images"
                        :key="image.uuid"
                        :src="image.url"
                        :alt="details.name"
                        class="rounded border m-1 cursor-pointer"
                        style="width: 70px; height: 50px; object-fit: cover;"
                        @click="selectedImage = image.url"
                    >
                </div>
            </b-container>
            <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('meeting-room-image-' + details.uuid)">
                    {{ $t('label.cancel') }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
export default {
    props: {
        details: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedImage: null,
        };
    },
    computed: {
        imageUrl() {
            return this.details.image || this.details.images.find(item => item.isMainImage)?.url || this.details.images[0]?.url || null;
        },
    },
}
</script>
